<template>
  <v-content class="mx-4">
    <!--Menu Nevigation-->
    <!--if tap = 1-->
    <v-layout v-if="tab === 1">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">รายงาน</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281">สถิติการสั่งพิมพ์ทั้งหมด</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <!--if tap = 2-->
    <v-layout v-if="tab === 2">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">รายงาน</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>ประวัติการพิมพ์เพื่อจัดหา</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <!--if tap = 3-->
    <v-layout v-if="tab === 3">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">รายงาน</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>ประวัติการเข้าใช้งานทั้งหมด</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <!--if tap = 4-->
    <v-layout v-if="tab === 4">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">รายงาน</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>สป. ที่ไม่ถูกจัดพิมพ์เกิน 5 ปี</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!--Menu Bar-->
    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          สถิติการสั่งพิมพ์ทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 2" :class="{active: tab === 2}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          ประวัติการพิมพ์เพื่อจัดหา
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 3" :class="{active: tab === 3}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          ประวัติการเข้าใช้งานทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 4" :class="{active: tab === 4}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          สป. ที่ไม่ถูกจัดพิมพ์เกิน 5 ปี
        </v-btn>
      </v-flex>

      <!-- Button Export -->
      <v-flex style="text-align: right;position: absolute;top:45px;right:130px;">
        <v-btn class="mr-1" color="#84A2A8"
               style="color: white;border-radius: 50px;text-align: right;"
               @click="getLike">
          <v-icon dark class="mr-1">save_alt</v-icon>
          <span>Export Like and dislike</span>
        </v-btn>
      </v-flex>

      <v-flex style="text-align: right;position: absolute;top:45px;right:0px;">
        <v-btn v-if="tab == 1" class="mr-1" color="#84A2A8"
               style="color: white;border-radius: 50px;text-align: right;"
               @click="onExportStat">
          <v-icon dark class="mr-1">save_alt</v-icon>
          <span>Export</span>
        </v-btn>
      </v-flex>

      <v-flex style="text-align: right;position: absolute;top:45px;right:0px;">
        <v-btn v-if="tab == 2" class="mr-1" color="#84A2A8"
               style="color: white;border-radius: 50px;text-align: right;"
               @click="onExportHistoryOrder">
          <v-icon dark class="mr-1">save_alt</v-icon>
          <span>Export</span>
        </v-btn>
      </v-flex>
      <v-flex style="text-align: right;position: absolute;top:45px;right:0px;">
        <v-btn v-if="tab == 3" class="mr-1" color="#84A2A8"
               style="color: white;border-radius: 50px;text-align: right;"
               @click="onExportHistoryLogin">
          <v-icon dark class="mr-1">save_alt</v-icon>
          <span>Export</span>
        </v-btn>
      </v-flex>
      <v-flex style="text-align: right;position: absolute;top:45px;right:0px;">
        <v-btn v-if="tab == 4" class="mr-1" color="#84A2A8"
               style="color: white;border-radius: 50px;text-align: right;"
               @click="onExportToolNotPrint">
          <v-icon dark class="mr-1">save_alt</v-icon>
          <span>Export</span>
        </v-btn>
      </v-flex>

    </v-layout>

    <!-- Tap Stat Printing All -->
    <template v-if="tab === 1">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               color="#527281"
               :is-full-page="fullPage">
      </loading>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;"
                class="report-tab-1 search-Data-Form">
          <v-layout>
            <v-flex shrink mr-4 mt-1>
              <span style="font-size: 20px;font-weight: bold;">ค้นหาข้อมูล : </span>
            </v-flex>
            <!-- header search of Main Group -->
            <template>
              <v-flex xs3 mr-4>
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="selectMainGroup"
                  :items="optionSpec"
                  item-text="option_select_main_group"
                  item-value="group_main"
                  hide-details
                  color="#ffffff"
                  single-line
                  placeholder="กลุ่ม"
                  outlined
                  dark
                  clearable
                >
                </v-select>
              </v-flex>
              <v-flex shrink mr-4 mt-1>
                <span style="font-size: 18px;font-weight: bold;">ช่วงวันที่ : </span>
              </v-flex>

              <v-flex xs2 mr-2>
                <v-menu
                  v-model="menuDateStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      v-model="mainGroupDateStart"
                      single-line
                      outlined
                      dark
                      clearable
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mainGroupDateStart"
                    @input="menuDateStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex shrink mt-2 mr-2>
                ถึง:
              </v-flex>
              <v-flex xs2 mr-2>
                <v-menu
                  v-model="menuDateEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      hide-details
                      v-model="mainGroupDateEnd"
                      placeholder="สิ้นสุด"
                      single-line
                      outlined
                      dark
                      clearable
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mainGroupDateEnd"
                    @input="menuDateEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex shrink>
                <v-btn @click="searchStatGroup" style="border-radius: 20px;color: #527281">ค้นหา</v-btn>
              </v-flex>
            </template>

          </v-layout>
        </v-flex>
      </v-layout>

      <!-- แสดงข้อมูลสถิติ -->
      <v-layout justify-center class="table-search">
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="optionStatHeader"
                :items="showDataStatReport"
                :hide-default-footer="true"
              >
                <template v-slot:item.name_medspec="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.name_medspec}}
                  </v-flex>
                </template>
                <template v-slot:item.group_num="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.group_num}}
                  </v-flex>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationState.last_page"
            :total-visible="9"
            @input="getPaginationState"
            v-model="paginationState.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </template>

    <!-- Tap History Printing for Order -->
    <template v-if="tab === 2" :class="{active: tab === 2}">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               color="#527281"
               :is-full-page="fullPage">
      </loading>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;"
                class="report-tab-2 search-Data-Form">
          <v-layout>

            <v-flex shrink mr-4>
              <span style="font-size: 18px;font-weight: bold;">เลือกการค้นหา : </span>
            </v-flex>

            <v-flex xs2 mr-2 class="search-Data-Form">
              <v-text-field
                class="custom-placeholer-color"
                hide-details
                v-model="order_id"
                :menu-props="{ bottom: true, offsetY: true }"
                placeholder="เลขที่เอกสาร"
                color="#ffffff"
                single-line
                outlined
                dark
              ></v-text-field>
            </v-flex>

            <v-flex xs2 mr-4>
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
                label="สถานะ"
                v-model="statusHistoryOrderSelect"
                :items="statusOrderHistory"
                color="#ffffff"
                single-line
                outlined
                dark
                clearable
              >
              </v-select>
            </v-flex>

            <v-flex shrink mr-4 mt-1>
              <span style="font-size: 18px;font-weight: bold;">ช่วงวันที่ : </span>
            </v-flex>

            <v-flex xs2 mr-2>
              <v-menu
                v-model="menuDateStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="historyOrderDateStart"
                    single-line
                    outlined
                    placeholder="เริ่มต้น"
                    dark
                    clearable
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="historyOrderDateStart"
                  @input="menuDateStart = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex shrink mt-1 mr-2>
              ถึง:
            </v-flex>
            <v-flex xs2 mr-2>
              <v-menu
                v-model="menuDateEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="historyOrderDateEnd"
                    label="Picker without buttons"
                    single-line
                    outlined
                    placeholder="สิ้นสุด"
                    dark
                    clearable
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="historyOrderDateEnd"
                  @input="menuDateEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex shrink>
              <v-btn @click="searchOrderHistory" style="border-radius: 20px;color: #527281">ค้นหา</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center class="">
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headerSearchHistoryOrder"
                :items="showDataSearchHistoryOrder"
                :hide-default-footer="true"
              >
                <template v-slot:item.name_medspec="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.name_medspec}}
                  </v-flex>
                </template>
                <template v-slot:item.user_name_order="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.user_name_order}}
                  </v-flex>
                </template>
                <template v-slot:item.organization_name="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.organization_name}}
                  </v-flex>
                </template>
                <template v-slot:item.order="{ item }">
                  <v-icon style="color: #D97C57;cursor: pointer;" @click="getHistoryOrderPdf(item.medspec_id,item.order_id)">attach_file</v-icon>
                </template>
                <template v-slot:item.status="{ item }">
                  <span @click="onchangeOrderStatus(item)"
                        style="text-decoration: underline;color: #D97C57;cursor: pointer;"
                  >
                    {{item.status === '1' ? 'ใช้งาน' : 'ยกเลิก'}}
                  </span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationOrder.last_page"
            :total-visible="9"
            @input="getPaginationOrder"
            v-model="paginationOrder.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>

    </template>

    <!-- Tap History Login All -->
    <template v-if="tab == 3">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               color="#527281"
               :is-full-page="fullPage">
      </loading>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;"
                class="report-tab-3 search-Data-Form">
          <v-layout>

            <v-flex shrink mr-4>
              <span style="font-size: 18px;font-weight: bold;">เลือกการค้นหา : </span>
            </v-flex>

            <v-flex xs2 mr-2 class="search-Data-Form">
              <v-select
                class="custom-placeholer-color"
                hide-details
                :menu-props="{ bottom: true, offsetY: true }"
                label="หน่วยงาน"
                v-model="selectDepartment"
                :items="optionDepartment"
                item-text="option_select_organize"
                item-value="id"
                color="#ffffff"
                single-line
                clearable
                outlined
                dark
              ></v-select>
            </v-flex>

            <v-flex xs2 mr-4>
              <v-text-field
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
                placeholder="บัญชีผู้ใช้งาน"
                v-model="user_name"
                color="#ffffff"
                single-line
                outlined
                dark
              >
              </v-text-field>
            </v-flex>

            <v-flex shrink mr-4 mt-1>
              <span style="font-size: 18px;font-weight: bold;">ช่วงวันที่ : </span>
            </v-flex>

            <v-flex xs2 mr-2>
              <v-menu
                v-model="menuDateStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="historyLoginDateStart"
                    single-line
                    outlined
                    dark
                    clearable
                    placeholder="เริ่มต้น"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="historyLoginDateStart"
                  @input="menuDateStart = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex shrink mt-1 mr-2>
              ถึง:
            </v-flex>
            <v-flex xs2 mr-2>
              <v-menu
                v-model="menuDateEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="historyLoginDateEnd"
                    single-line
                    outlined
                    dark
                    clearable
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="historyLoginDateEnd"
                  @input="menuDateEnd = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex shrink>
              <v-btn @click="searchHistoryLogin" style="border-radius: 20px;color: #527281">ค้นหา</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headerSearchHistoryLogin"
                :items="showDataSearchHistoryLogin"
                :hide-default-footer="true"
              >
                <template v-slot:item.user_name="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.user_name}}
                  </v-flex>
                </template>
                <template v-slot:item.name_department="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.name_department}}
                  </v-flex>
                </template>
                <template v-slot:item.keyword_search="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.keyword_search}}
                  </v-flex>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationLogin.last_page"
            :total-visible="9"
            @input="getPaginationLogin"
            v-model="paginationLogin.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>

    </template>

    <!-- Tap SP not Print More than 5 years  -->
    <template v-if="tab == 4">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               color="#527281"
               :is-full-page="fullPage">
      </loading>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;"
                class="report-tab-4 search-Data-Form">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">ค้นหา ช่วงวันที่ : </span>
            </v-flex>
            <v-flex shrink mr-2>
              <v-menu
                v-model="menuDateStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="notPrintDateStart"
                    single-line
                    outlined
                    dark
                    clearable
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="notPrintDateStart"
                  @input="menuDateStart = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex shrink mt-1 mr-2>
              ถึง:
            </v-flex>
            <v-flex shrink mr-2>
              <v-menu
                v-model="menuDateEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    hide-details
                    v-model="notPrintDateEnd"
                    single-line
                    outlined
                    dark
                    clearable
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="notPrintDateEnd"
                  @input="menuDateEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex shrink>
              <v-btn @click="searchToolNotOrder" style="border-radius: 20px;color: #527281">ค้นหา</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headerSearchNotPrint"
                :items="showDataSearchNotPrint"
                :hide-default-footer="true"
              >
                <template v-slot:item.mainGroupSp="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.mainGroupSp}}
                  </v-flex>
                </template>
                <template v-slot:item.nameSpTh="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.nameSpTh}}
                  </v-flex>
                </template>
                <template v-slot:item.nameSpEn="{ item }">
                  <v-flex ml-4 my-2 style="text-align: left;">
                    {{item.nameSpEn}}
                  </v-flex>
                </template>
                <template v-slot:item.status="{ item }">
                <span @click="onChangeNotPrintStatus(item)"
                      style="text-decoration: underline;color: #D97C57;cursor: pointer;">
                  {{item.status === '1' ? 'ใช้งาน' : 'ยกเลิก'}}
                </span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationNotPrint.last_page"
            :total-visible="9"
            @input="getPaginationNotPrint"
            v-model="paginationNotPrint.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>

      <!-- Form Dialog  -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="700px">
            <v-card>
              <v-card-title>
                <span style="font-weight: bold">แก้ไขสถานะอุปกรณ์</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" lazy-validation>
                  <v-flex xs12 class="dialog-detail">
                    <v-layout>
                      <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                        เลขที่ สป. :
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field v-if="recordIndex !== null"
                                      readonly
                                      flat
                                      v-model="showDataSearchNotPrint[recordIndex].spec_no"
                                      background-color="#E5E5E5"
                                      value=""
                                      item-color="#84A2A8"
                                      solo
                                      :rules="noSpRules"
                                      required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                        กลุ่มหลัก สป.
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field v-if="recordIndex !== null"
                                      readonly
                                      v-model="showDataSearchNotPrint[recordIndex].mainGroupSp"
                                      flat
                                      background-color="#E5E5E5"
                                      value=""
                                      item-color="#84A2A8"
                                      solo
                                      :rules="mainGroupSpRules"
                                      required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                        ชื่อ สป.
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field v-if="recordIndex !== null"
                                      readonly
                                      v-model="showDataSearchNotPrint[recordIndex].nameSp"
                                      flat
                                      background-color="#E5E5E5"
                                      value=""
                                      item-color="#84A2A8"
                                      solo
                                      :rules="nameSpRules"
                                      required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3 class="mr-4 mt-1" style="text-align: right;font-weight: bold">
                        วันที่ถูกจัดพิมพ์ล่าสุด :
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field v-if="recordIndex !== null"
                                      readonly
                                      v-model="showDataSearchNotPrint[recordIndex].datePrint"
                                      flat
                                      background-color="#E5E5E5"
                                      value=""
                                      item-color="#84A2A8"
                                      solo
                                      :rules="datePrintRules"
                                      required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3 class="mr-4" style="text-align: right;font-weight: bold">
                        สถานะ :
                      </v-flex>
                      <v-flex xs8 class="pl-3">
                        <v-radio-group class="ma-0 pa-0"
                                       :rules="statusRules"
                                       :mandatory="false"
                                       v-model="showDataSearchNotPrint[recordIndex].status"
                                       v-if="recordIndex !== null">
                          <v-row>
                            <v-radio label="ใช้งาน" value="ใช้งาน" class="pa-0 ma-0"></v-radio>
                            <v-radio label="ยกเลิก" value="ยกเลิก" class="ml-4"></v-radio>
                          </v-row>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout class="mb-4" justify-center>
                  <v-flex shrink class="ma-2">
                    <v-btn style="background-color: #BDBDBD; color: white;border-radius: 25px;" @click="dialog = false">
                      ย้อนกลับ
                    </v-btn>
                  </v-flex>
                  <v-flex shrink class="ma-2">
                    <v-btn
                      style="background-color: #527281; color: white;border-radius: 25px;"
                      @click="editStatus(dataSearchNotPrint[recordIndex].noSp)">
                      ยืนยันการแก้ไข
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

    </template>

  </v-content>
</template>

<script>
    import validate from "../utils/validate";
    import Service from '../service';
    import XLSX from 'xlsx' // import xlsx;
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';


    export default {
        name: "Report",
        components: {
            Loading
        },
        data: () => ({
            isLoading: false,
            fullPage: false,
            count_search_state: null,
            paginationState: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            count_search_order: null,
            paginationOrder: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            count_search_login: null,
            paginationLogin: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            count_search_not_print: null,
            paginationNotPrint: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },

            menuDateStart: false,
            menuDateEnd: false,
            searchYear: null,
            selectToShow: 0,
            tab: 1,
            dataSelect: [
                {text: 'กลุ่มหลัก สป.', value: 1},
                {text: 'ปีที่จัดทำ', value: 2},
            ],

            selectMainGroup: null,
            mainGroupDateStart: new Date().toISOString().substr(0, 10),
            mainGroupDateEnd: new Date().toISOString().substr(0, 10),
            optionSpec:[],

            // Tab 1 -> Stat Tools
            optionStatHeader: [
                {text: 'เลขที่ สป.', value: 'spec_no', sortable: true, align: 'center', width: '15%'},
                {text: 'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (ไทย)', value: 'name_medspec', sortable: true, align: 'center', width: '15%'},
                {text: 'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (อังกฤษ)', value: 'name_medspec_en', sortable: true, align: 'center', width: '15%'},
                {text: 'กลุ่ม สป.', value: 'group_num', sortable: true, align: 'center', width: '15%'},
                {text: 'ปีที่จัดทำ', value: 'year', sortable: true, align: 'center', width: '5%'},
                {text: 'พิมพ์เพื่อจัดหา', value: 'count_print', sortable: true, align: 'center', width: '5%'},
                {text: 'พิมพ์เพื่อดู', value: 'count_view', sortable: true, align: 'center', width: '5%'},
            ],
            showDataStatReport: [],

            // Tab 2 -> HistoryOrder
            order_id: '',
            historyOrderDateStart: new Date().toISOString().substr(0, 10),
            historyOrderDateEnd: new Date().toISOString().substr(0, 10),
            statusHistoryOrderSelect: null,
            statusOrderHistory: [
                {text: 'ใช้งาน', value: '1'},
                {text: 'ยกเลิก', value: '2'},
            ],
            headerSearchHistoryOrder: [
                {text: 'เลขที่เอกสารการจัดหา', value: 'order_id', sortable: true, align: 'center',},
                {text: 'เลขที่ สป.', value: 'spec_no', sortable: true, align: 'center',},
                {text: 'ชื่อ สป. (ไทย)', value: 'name_medspec', sortable: true, align: 'center',},
                {text: 'ชื่อ สป. (อังกฤษ)', value: 'name_medspec_en', sortable: true, align: 'center',},
                {text: 'ชื่อผู้ใช้งาน', value: 'user_name_order', sortable: true, align: 'center',},
                {text: 'ชื่อหน่วยงาน', value: 'organization_name', sortable: true, align: 'center',},
                {text: 'วันที่/เวลา พิมพ์เอกสาร', value: 'date', sortable: true, align: 'center',},
                {text: 'IP Address', value: 'ip', sortable: true, align: 'center',},
                {text: 'จัดหา', value: 'order', sortable: true, align: 'center',},
                {text: 'สถานะ', value: 'status', sortable: true, align: 'center',},
            ],
            showDataSearchHistoryOrder: [],

            //Tab 3 -> History Login
            selectDepartment: '',
            optionDepartment: [],
            user_name: '',
            historyLoginDateStart: new Date().toISOString().substr(0, 10),
            historyLoginDateEnd: new Date().toISOString().substr(0, 10),
            headerSearchHistoryLogin: [
                {text: 'รหัสผู้ใช้งาน', value: 'user_id', sortable: true, align: 'center', width:'5%'},
                {text: 'ชื่อ-นามสกุล', value: 'user_name', sortable: true, align: 'center', width:'15%'},
                {text: 'ชื่อหน่วยงาน', value: 'name_department', sortable: true, align: 'center',width:'15%'},
                {text: 'ประวัติการค้นหา', value: 'keyword_search', sortable: true, align: 'center',width:'30%'},
                {text: 'ประวัติการเข้าใช้งาน', value: 'updated_at', sortable: true, align: 'center',width:'15%'},
                {text: 'IP Address', value: 'ip_address', sortable: true, align: 'center',width:'15%'},
            ],
            showDataSearchHistoryLogin: [],

            // Tab 4 -> SP not Print More than 5 years
            notPrintDateStart: new Date().toISOString().substr(0, 10),
            notPrintDateEnd: new Date().toISOString().substr(0, 10),
            headerSearchNotPrint: [
                {text: 'เลขที่ สป.', value: 'spec_no', sortable: true, align: 'center', width: '10%'},
                {text: 'กลุ่มหลัก สป.', value: 'mainGroupSp', sortable: true, align: 'center', width: '22%'},
                {text: 'ชื่อ สป.(ไทย)', value: 'nameSpTh', sortable: true, align: 'center', width: '22%'},
                {text: 'ชื่อ สป.(อังกฤษ)', value: 'nameSpEn', sortable: true, align: 'center', width: '22%'},
                {text: 'วันที่ถูกจัดพิมพ์ล่าสุด', value: 'datePrint', sortable: true, align: 'center', width: '15%'},
                {text: 'สถานะอุปกรณ์', value: 'status', sortable: true, align: 'center', width: '10%'},
            ],
            showDataSearchNotPrint: [],

            dialog: false,
            recordIndex: null,
            form: {
                noSp: "",
                mainGroupSp: "",
                nameSp: "",
                datePrint: "",
                status: "",
            },
            noSpRules: [
                v => validate.required(v, "noSp"),
            ],
            mainGroupSpRules: [
                v => validate.required(v, "mainGroupSp"),
            ],
            nameSpRules: [
                v => validate.required(v, "nameSp"),
            ],
            datePrintRules: [
                v => validate.required(v, "datePrint"),
            ],
            statusRules: [
                v => validate.required(v, "status"),
            ],

            // Exprot Excel
            json_like_and_dislike : [],
            json_stat_printing : [],
            json_history_order : [],
            json_history_login : [],
            json_data_not_print : [],
        }),
        mounted () {
            this.getMainGroup();
            this.getStatReport();
            this.getHistoryOrder();
            this.getHistoryLogin();
            this.getToolNotPrint();
            this.getOrganization();
            // this.getLike();
        },
        methods: {
            onchangeOrderStatus(data) {
                let ok = confirm('ต้องการเปลี่ยนสถานะหรือไม่?')
                if(ok) {
                    let data_order = {
                        id: data.id,
                        status: data.status  === '2' ? '1' : '2',
                    }
                    this.isLoading = true;
                    Service.Report.changeOrderStatus(data_order).then(data => {
                        this.showDataSearchHistoryOrder = this.showDataSearchHistoryOrder.map(dataSearch => {
                            if(+data.id === +dataSearch.id) {
                                return {
                                    id: `${data.id}`,
                                    medspec_id: `${data.medspec_id}`,
                                    order_id: `${data.order_id}`,
                                    spec_no: data.med_spec ? data.med_spec.spec_no : "-",
                                    name_medspec: data.med_spec ? data.med_spec.name_th : "-",
                                    name_medspec_en: data.med_spec ? data.med_spec.name_en : "-",
                                    user_name_order: data.user ? data.user.firstname : "-",
                                    organization_name: data.user && data.user.organization ? data.user.organization.name : "-",
                                    date: `${data.created_at}`,
                                    ip: `${data.ip_address}`,
                                    order: `${data.year}`,
                                    status: data.status,
                                }
                            } else {
                                return dataSearch
                            }
                        })
                    })
                    // this.isLoading = false;
                }

            },
            onChangeNotPrintStatus(data) {
                let ok = confirm('ต้องการเปลี่ยนสถานะหรือไม่?')
                if(ok) {
                    let data_notOrder = {
                        id: data.id,
                        status: data.status === '1' ? '0' : '1',
                    }
                    this.isLoading = true;
                    Service.MedicalTool.updateStatusNotPrint(data_notOrder).then(res => {
                        this.showDataSearchNotPrint = this.showDataSearchNotPrint.map(change_data => {
                            if(+res.id === +change_data.id) {
                                return {
                                    id: `${res.id}`,
                                    spec_no: `${res.spec_no}`,
                                    mainGroupSp: this.checkTryCash2(res, 'spec_group_', 'main_group_desc'),
                                    nameSpTh: `${data_not_print.name_th}`,
                                    nameSpEn: `${data_not_print.name_en}`,
                                    datePrint : `${res.last_date}`,
                                    status: res.status,
                                }
                            }else {
                                return change_data
                            }
                            this.isLoading = false;
                        })
                    })
                    this.isLoading = false;
                }
            },

            getMainGroup() {
                this.isLoading = true;
                Service.SpecGroup.getSearchMainGroup().then(data => {
                    data.forEach(mainGroup => {
                        this.optionSpec.push({
                            option_select_main_group:  `หมวดหมู่ ${mainGroup.group_main} ${mainGroup.main_group_desc}`,
                            group_num: `${mainGroup.group_num}`,
                            group_main: `${mainGroup.group_main}`
                        });
                        this.isLoading = false;
                    })
                })
            },
            // Get Data
            getStatReport() {
                this.isLoading = true;
                  Service.Report.getStatReport(this.paginationState.current_page).then(res => {
                      res.data.forEach(statReport => {
                          this.showDataStatReport.push({
                              spec_no: statReport.med_spec.spec_no ? statReport.med_spec.spec_no : "-",
                              group_num: this.checkTryCash3(statReport, 'med_spec', 'spec_group_', 'main_group_desc'),
                              name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                              name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                              count_print: statReport.order_buy,
                              count_view: statReport.view_order,
                              year: statReport.med_spec.year,
                          })
                      })
                      this.paginationState.current_page = res.current_page;
                      this.paginationState.from = res.from;
                      this.paginationState.last_page = res.last_page;
                      this.paginationState.per_page = res.per_page;
                      this.paginationState.total = res.total;
                      this.paginationState.to = res.to;
                      this.isLoading = false;
                  })

                Service.Report.getStatReport_excel().then(res => {
                    res.forEach(statReport => {
                        this.json_stat_printing.push({
                            'เลขที่ สป.': statReport.med_spec ? statReport.med_spec.spec_no : "-",
                            'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (ไทย)': statReport.med_spec ? statReport.med_spec.name_th : "-",
                            'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (อังกฤษ)': statReport.med_spec ? statReport.med_spec.name_en : "-",
                            'กลุ่ม สป.' : this.checkTryCash3(statReport, 'med_spec', 'spec_group_', 'main_group_desc'),
                            'ปีที่จัดทำ': statReport.med_spec ? statReport.med_spec.year : "-",
                            'พิมพ์เพื่อจัดหา': `${statReport.order_buy}`+' ครั้ง',
                            'พิมพ์เพื่อดู': `${statReport.view_order}`+' ครั้ง',
                        })
                    })
                })
            },
            getHistoryOrder() {
                this.isLoading = true;
                Service.Report.getHistoryOrder(this.paginationOrder.current_page).then(res => {
                    res.data.forEach(statReport => {
                            this.showDataSearchHistoryOrder.push({
                                id: statReport.id,
                                medspec_id: statReport.medspec_id,
                                order_id: statReport.order_id,
                                spec_no: statReport.med_spec ? statReport.med_spec.spec_no : "-",
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                user_name_order: statReport.user.firstname,
                                organization_name: statReport.user.organization.name,
                                date: statReport.created_at,
                                ip: statReport.ip_address,
                                order: statReport.year,
                                status: statReport.status,
                            })
                    })
                    this.paginationOrder.current_page = res.current_page;
                    this.paginationOrder.from = res.from;
                    this.paginationOrder.last_page = res.last_page;
                    this.paginationOrder.per_page = res.per_page;
                    this.paginationOrder.total = res.total;
                    this.paginationOrder.to = res.to;
                    this.isLoading = false;
                })
                Service.Report.getHistoryOrderExcel().then(res => {
                    res.forEach(statReport => {
                        this.json_history_order.push({
                            'เลขที่เอกสารการจัดหา': `${statReport.order_id}`,
                            'ชื่อ สป. (ไทย)': statReport.med_spec ? statReport.med_spec.name_th : "-",
                            'ชื่อ สป. (อังกฤษ)': statReport.med_spec ? statReport.med_spec.name_en : "-",
                            'ชื่อผู้ใช้งาน': statReport.user ? statReport.user.firstname : "-",
                            'ชื่อหน่วยงาน': statReport.user && statReport.user.organization ? statReport.user.organization.name : "-",
                            'วันที่/เวลา พิมพ์เอกสาร': `${statReport.created_at}`,
                            'IP Address': `${statReport.ip_address}`,
                            'จัดหา': `${statReport.year}`,
                            'สถานะ': statReport.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                        })
                    })
                })
            },
            getHistoryLogin() {
                this.isLoading = true;
              Service.Common.getHistoryLogin(this.paginationLogin.current_page).then(res => {
                  res.data.forEach(history_login => {
                    this.showDataSearchHistoryLogin.push({
                        user_id: `${history_login.user_id}`,
                        user_name: `${history_login.user.firstname} ${history_login.user.lastname}`,
                        name_department: history_login.user.organization === null ? '-' : history_login.user.organization.name,
                        keyword_search: history_login.keyword_search === null ? '-' : history_login.keyword_search,
                        updated_at: `${history_login.updated_at}`,
                        ip_address: `${history_login.ip_address}`,
                        id: `${history_login.id}`,
                    })
                    this.json_history_login.push({
                        'รหัสผู้ใช้งาน': `${history_login.user_id}`,
                        'ชื่อ-นามสกุล': `${history_login.user.firstname} ${history_login.user.lastname}`,
                        'ชื่อหน่วยงาน': history_login.user.organization === null ? '-' : history_login.user.organization.name,
                        'ประวัติการค้นหา': history_login.keyword_search === null ? '-' : history_login.keyword_search,
                        'ประวัติการเข้าใช้งาน': `${history_login.updated_at}`,
                        'IP Address': `${history_login.ip_address}`,
                    })
                  })
                  this.paginationLogin.current_page = res.current_page;
                  this.paginationLogin.from = res.from;
                  this.paginationLogin.last_page = res.last_page;
                  this.paginationLogin.per_page = res.per_page;
                  this.paginationLogin.total = res.total;
                  this.paginationLogin.to = res.to;
                  this.isLoading = false;
              })
              Service.Common.getHistoryLoginExcel().then(res => {
                  res.forEach(history_login => {
                    this.json_history_login.push({
                        'รหัสผู้ใช้งาน': `${history_login.user_id}`,
                        'ชื่อ-นามสกุล': history_login.user ? `${history_login.user.firstname} ${history_login.user.lastname}` : "-",
                        'ชื่อหน่วยงาน': history_login.user ? history_login.user.organization.name : "-",
                        'ประวัติการค้นหา': history_login.keyword_search === null ? '-' : history_login.keyword_search,
                        'ประวัติการเข้าใช้งาน': `${history_login.updated_at}`,
                        'IP Address': `${history_login.ip_address}`,
                    })
                  })
              })
            },
            getToolNotPrint() {
                this.isLoading = true;
                Service.Report.getToolNotPrintOverFiveYear(this.paginationNotPrint.current_page).then(res => {
                    res.data.forEach(data_not_print => {
                        this.showDataSearchNotPrint.push({
                            id: `${data_not_print.id}`,
                            spec_no: `${data_not_print.spec_no}`,
                            mainGroupSp: this.checkTryCash2(data_not_print, 'spec_group_', 'main_group_desc'),
                            nameSpTh: `${data_not_print.name_th}`,
                            nameSpEn: `${data_not_print.name_en}`,
                            datePrint : `${data_not_print.last_date}`,
                            status: data_not_print.status,
                        })
                        this.json_data_not_print.push({
                            'เลขที่ สป.': `${data_not_print.spec_no}`,
                            'กลุ่มหลัก สป.':  this.checkTryCash2(data_not_print, 'spec_group_', 'main_group_desc'),
                            'ชื่อ สป.(ไทย)': `${data_not_print.name_th}`,
                            'ชื่อ สป.(อังกฤษ)': `${data_not_print.name_en}`,
                            'วันที่ถูกจัดพิมพ์ล่าสุด' : `${data_not_print.last_date}`,
                            'สถานะอุปกรณ์': data_not_print.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                        })
                    })
                    this.paginationNotPrint.current_page = res.current_page;
                    this.paginationNotPrint.from = res.from;
                    this.paginationNotPrint.last_page = res.last_page;
                    this.paginationNotPrint.per_page = res.per_page;
                    this.paginationNotPrint.total = res.total;
                    this.paginationNotPrint.to = res.to;
                    this.isLoading = false;
                })
                Service.Report.getToolNotPrintOverFiveYearExcel().then(res => {
                    res.forEach(data_not_print => {
                        this.json_data_not_print.push({
                            'เลขที่ สป.': `${data_not_print.spec_no}`,
                            'กลุ่มหลัก สป.':  this.checkTryCash2(data_not_print, 'spec_group_', 'main_group_desc'),
                            'ชื่อ สป.': `${data_not_print.name_th}`,
                            'ชื่อ สป.(อังกฤษ)': `${data_not_print.name_en}`,
                            'วันที่ถูกจัดพิมพ์ล่าสุด' : `${data_not_print.last_date}`,
                            'สถานะอุปกรณ์': data_not_print.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                        })
                    })
                })
            },
            getLike() {
                this.isLoading = true;
                Service.Common.getLike().then(res => {
                    res.forEach(data => {
                        this.json_like_and_dislike.push({
                            'รหัสผู้ใช้งาน': data.id,
                            'ชื่อผู้ใช้งาน': data.user ? data.user.firstname+" "+data.user.lastname : "-",
                            'หน่วยงาน': data.user && data.user.organization ? data.user.organization.name : "-",
                            'ประเมินความพึงพอใจการใช้งานระบบ': data.like_or_dislike ? "พึงพอใจ" : "ไม่พึงพอใจ",
                            'เวลาที่ประเมิน': data.updated_at ? data.updated_at : "-",
                        })
                    })
                    this.isLoading = false;
                    this.onExportLikeAndDisLike();
                })
            },

            //Search*****************************************************
            searchStatGroup() {
                if(this.mainGroupDateStart && !this.mainGroupDateEnd) {
                    alert('กรุณาเลือกช่วงวันที่สิ้นสุด')
               } else if(!this.mainGroupDateStart && this.mainGroupDateEnd) {
                   alert('กรุณาเลือกช่วงวันที่เริ่มต้น')
               } else {
                   this.paginationState.current_page = 1;
                   this.paginationState.from = 1;
                   this.paginationState.last_page = 1;
                   this.paginationState.per_page = 1;
                   this.paginationState.total = 1;
                   this.paginationState.to = 1;
                   this.count_search_state = 1;
                   let data = {
                       main_group: this.selectMainGroup,
                       start_date: this.mainGroupDateStart,
                       end_date: this.mainGroupDateEnd,
                       page: this.paginationState.current_page,
                   }
                   this.isLoading = true;
                   this.showDataStatReport = [];
                   Service.Report.getSearchStatReport(data.page, data.main_group, data.start_date, data.end_date).then(res => {
                       res.data.forEach(statReport => {
                           this.showDataStatReport.push({
                               spec_no: statReport.med_spec.spec_no ? statReport.med_spec.spec_no : "-",
                               group_num: this.checkTryCash3(statReport,'med_spec','spec_group_','main_group_desc'),
                               // group_num: `${statReport.med_spec.spec_group_.main_group_desc}`,
                               name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                               name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                               count_print: `${statReport.order_buy}`,
                               count_view: `${statReport.view_order}`,
                               year: `${statReport.med_spec.year}`,
                           })
                       })
                       this.paginationState.current_page = res.current_page;
                       this.paginationState.from = res.from;
                       this.paginationState.last_page = res.last_page;
                       this.paginationState.per_page = res.per_page;
                       this.paginationState.total = res.total;
                       this.paginationState.to = res.to;
                       this.isLoading = false;
                   })
               }
            },
            searchOrderHistory() {
                if(!this.historyOrderDateStart && !this.historyOrderDateEnd && !this.order_id && !this.statusHistoryOrderSelect) {
                    alert('กรุณาใส่ข้อมูลการค้นหา')
                }else if(this.historyOrderDateStart && !this.historyOrderDateEnd) {
                    alert('กรุณาเลือกช่วงวันที่สิ้นสุด')
                } else if(!this.historyOrderDateStart && this.historyOrderDateEnd) {
                    alert('กรุณาเลือกช่วงวันที่เริ่มต้น')
                }else {
                    this.paginationOrder.current_page = 1;
                    this.paginationOrder.from = 1;
                    this.paginationOrder.last_page = 1;
                    this.paginationOrder.per_page = 1;
                    this.paginationOrder.total = 1;
                    this.paginationOrder.to = 1;
                    this.count_search_order = 1;
                    let data = {
                        page: this.paginationOrder.current_page,
                        order_id: this.order_id,
                        status: this.statusHistoryOrderSelect,
                        date_start: this.historyOrderDateStart,
                        date_end: this.historyOrderDateEnd,
                    }
                    this.isLoading = true;
                    this.showDataSearchHistoryOrder = [];
                    Service.Report.getHistoryOrderSearch(data.page,data.order_id,data.status,data.date_start,data.date_end).then(res => {
                        res.data.forEach(statReport => {
                            this.showDataSearchHistoryOrder.push({
                                id: `${statReport.id}`,
                                medspec_id: `${statReport.medspec_id}`,
                                order_id: `${statReport.order_id}`,
                                spec_no: `${statReport.med_spec.spec_no}`,
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                user_name: `${statReport.user.username}`,
                                organization_name: `${statReport.user.organization.name}`,
                                date: `${statReport.created_at}`,
                                ip: `${statReport.ip_address}`,
                                order: `${statReport.year}`,
                                status: statReport.status,
                            })
                        })
                        this.paginationOrder.current_page = res.current_page;
                        this.paginationOrder.from = res.from;
                        this.paginationOrder.last_page = res.last_page;
                        this.paginationOrder.per_page = res.per_page;
                        this.paginationOrder.total = res.total;
                        this.paginationOrder.to = res.to;
                        this.isLoading = false;
                    })
                }
            },
            searchHistoryLogin() {
                this.isLoading = true;
                this.paginationLogin.current_page = 1;
                this.paginationLogin.from = 1;
                this.paginationLogin.last_page = 1;
                this.paginationLogin.per_page = 1;
                this.paginationLogin.total = 1;
                this.paginationLogin.to = 1;
                this.count_search_login = 1;
                let data = {
                    page: this.paginationLogin.current_page,
                    organization_id: this.selectDepartment,
                    user_name: this.user_name,
                    date_start: this.historyLoginDateStart,
                    date_end: this.historyLoginDateEnd,
                }
                this.showDataSearchHistoryLogin = [];
                Service.Common.getSearchHistoryLogin(data.page,data.organization_id, data.user_name, data.date_start, data.date_end).then(res => {
                    res.data.forEach(history_login => {
                        this.showDataSearchHistoryLogin.push({
                            user_id: `${history_login.user_id}`,
                            user_name: `${history_login.user.firstname} ${history_login.user.lastname}`,
                            name_department: `${history_login.user.organization.name}`,
                            keyword_search: history_login.keyword_search === null ? '-' : history_login.keyword_search,
                            updated_at: `${history_login.updated_at}`,
                            ip_address: `${history_login.ip_address}`,
                            id: `${history_login.id}`,
                        })
                    })
                    this.paginationLogin.current_page = res.current_page;
                    this.paginationLogin.from = res.from;
                    this.paginationLogin.last_page = res.last_page;
                    this.paginationLogin.per_page = res.per_page;
                    this.paginationLogin.total = res.total;
                    this.paginationLogin.to = res.to;
                    this.isLoading = false;
                })
            },
            async getOrganization() {
                this.isLoading = true;
                const res = await Service.Organization.showOrganizationAll();
                res.forEach(data_organization => {
                    let object = {
                        option_select_organize: data_organization.name,
                        id: data_organization.id
                    }
                    this.optionDepartment.push(object)
                })
            },
            searchToolNotOrder() {
                this.isLoading = true;
                this.paginationNotPrint.current_page = 1;
                this.paginationNotPrint.from = 1;
                this.paginationNotPrint.last_page = 1;
                this.paginationNotPrint.per_page = 1;
                this.paginationNotPrint.total = 1;
                this.paginationNotPrint.to = 1;
                this.count_search_not_print = 1;
                let data = {
                    page: this.paginationNotPrint.current_page,
                    date_start: this.notPrintDateStart,
                    date_end: this.notPrintDateEnd,
                }
                this.showDataSearchNotPrint = [];
                Service.Report.getSearchNotOrder(data.page,data.date_start,data.date_end).then(res => {
                    res.data.forEach(data_not_print => {
                        this.showDataSearchNotPrint.push({
                            id: `${data_not_print.id}`,
                            spec_no: `${data_not_print.spec_no}`,
                            mainGroupSp: this.checkTryCash2(data_not_print,'spec_group_','main_group_desc'),
                            // mainGroupSp: data_not_print.spec_group_.main_group_desc,
                            nameSpTh: `${data_not_print.name_th}`,
                            nameSpEn: `${data_not_print.name_en}`,
                            datePrint : `${data_not_print.last_date}`,
                            status: data_not_print.status,
                        })
                    })
                    this.paginationNotPrint.current_page = res.current_page;
                    this.paginationNotPrint.from = res.from;
                    this.paginationNotPrint.last_page = res.last_page;
                    this.paginationNotPrint.per_page = res.per_page;
                    this.paginationNotPrint.total = res.total;
                    this.paginationNotPrint.to = res.to;
                    this.isLoading = false;
                })
            },

            // Paginate *******************************************
            getPaginationState(page) {
                if (this.count_search_state === null) {
                    this.isLoading = true;
                    this.showDataStatReport = [];
                    Service.Report.getStatReport(page).then(res => {
                        res.data.forEach(statReport => {
                            this.showDataStatReport.push({
                                spec_no: statReport.med_spec.spec_no ? statReport.med_spec.spec_no : "-",
                                group_num: this.checkTryCash3(statReport, 'med_spec', 'spec_group_', 'main_group_desc'),
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                count_print: `${statReport.order_buy}`,
                                count_view: `${statReport.view_order}`,
                                year: statReport.med_spec ? statReport.med_spec.year : "-",
                            })
                            this.isLoading = false;
                            this.json_stat_printing.push({
                                'เลขที่ สป.': statReport.med_spec.spec_no ? statReport.med_spec.spec_no : "-",
                                'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (ไทย)': statReport.med_spec ? statReport.med_spec.name_th : "-",
                                'คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์ (อังกฤษ)': statReport.med_spec ? statReport.med_spec.name_en : "-",
                                'กลุ่ม สป.' : this.checkTryCash3(statReport, 'med_spec', 'spec_group_', 'main_group_desc'),
                                'ปีที่จัดทำ': statReport.med_spec ? statReport.med_spec.year : "-",
                                'พิมพ์เพื่อจัดหา': `${statReport.order_buy}`+' ครั้ง',
                                'พิมพ์เพื่อดู': `${statReport.view_order}`+' ครั้ง',
                            })
                        })
                        this.paginationState.current_page = res.current_page;
                        this.paginationState.from = res.from;
                        this.paginationState.last_page = res.last_page;
                        this.paginationState.per_page = res.per_page;
                        this.paginationState.total = res.total;
                        this.paginationState.to = res.to;
                    })
                } else {
                    this.isLoading = true;
                    let data = {
                        main_group: this.selectMainGroup,
                        start_date: this.mainGroupDateStart,
                        end_date: this.mainGroupDateEnd,
                        page: page,
                    }
                    this.showDataStatReport = [];
                    Service.Report.getSearchStatReport(data.page, data.main_group, data.start_date, data.end_date).then(res => {
                        res.data.forEach(statReport => {
                            this.showDataStatReport.push({
                                spec_no: statReport.med_spec.spec_no ? statReport.med_spec.spec_no : "-",
                                // group_num: `${statReport.med_spec.spec_group_.main_group_desc}`,
                                group_num: this.checkTryCash3(statReport,'med_spec','spec_group_','main_group_desc'),
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                count_print: `${statReport.order_buy}`,
                                count_view: `${statReport.view_order}`,
                                year: statReport.med_spec ? statReport.med_spec.year : "-",
                            })
                            this.isLoading = false;
                        })
                        this.paginationState.current_page = res.current_page;
                        this.paginationState.from = res.from;
                        this.paginationState.last_page = res.last_page;
                        this.paginationState.per_page = res.per_page;
                        this.paginationState.total = res.total;
                        this.paginationState.to = res.to;
                    })
                }

            },
            getPaginationOrder(page) {
                if(this.count_search_order === null) {
                    this.isLoading = true;
                    this.showDataSearchHistoryOrder = [];
                    Service.Report.getHistoryOrder(page).then(res => {
                        res.data.forEach(statReport => {
                            this.showDataSearchHistoryOrder.push({
                                id: `${statReport.id}`,
                                medspec_id: `${statReport.medspec_id}`,
                                order_id: `${statReport.order_id}`,
                                spec_no: statReport.med_spec ? statReport.med_spec.spec_no : "-",
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                user_name_order: statReport.user ? statReport.user.firstname : "-",
                                organization_name: `${statReport.user.organization.name}`,
                                date: `${statReport.created_at}`,
                                ip: `${statReport.ip_address}`,
                                order: `${statReport.year}`,
                                status: statReport.status,
                            })
                            this.json_history_order.push({
                                'เลขที่เอกสารการจัดหา': `${statReport.order_id}`,
                                'ชื่อ สป.': statReport.med_spec ? statReport.med_spec.name_th : "-",
                                'ชื่อผู้ใช้งาน': statReport.user ? statReport.user.firstname : "-",
                                'ชื่อหน่วยงาน': `${statReport.user.organization.name}`,
                                'วันที่/เวลา พิมพ์เอกสาร': `${statReport.created_at}`,
                                'IP Address': `${statReport.ip_address}`,
                                'จัดหา': `${statReport.year}`,
                                'สถานะ': statReport.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                            })
                        })
                        this.paginationOrder.current_page = res.current_page;
                        this.paginationOrder.from = res.from;
                        this.paginationOrder.last_page = res.last_page;
                        this.paginationOrder.per_page = res.per_page;
                        this.paginationOrder.total = res.total;
                        this.paginationOrder.to = res.to;
                        this.isLoading = false;
                    })
                } else {
                    this.isLoading = true;
                    let data = {
                        page: page,
                        order_id: this.order_id,
                        status: this.statusHistoryOrderSelect,
                        date_start: this.historyOrderDateStart,
                        date_end: this.historyOrderDateEnd,
                    }
                    this.showDataSearchHistoryOrder = [];
                    Service.Report.getHistoryOrderSearch(data.page,data.order_id,data.status,data.date_start,data.date_end).then(res => {
                        res.data.forEach(statReport => {
                            this.showDataSearchHistoryOrder.push({
                                id: `${statReport.id}`,
                                medspec_id: `${statReport.medspec_id}`,
                                order_id: `${statReport.order_id}`,
                                spec_no: `${statReport.med_spec.spec_no}`,
                                name_medspec: statReport.med_spec ? statReport.med_spec.name_th : "-",
                                name_medspec_en: statReport.med_spec ? statReport.med_spec.name_en : "-",
                                user_name: `${statReport.user.username}`,
                                organization_name: `${statReport.user.organization.name}`,
                                date: `${statReport.created_at}`,
                                ip: `${statReport.ip_address}`,
                                order: `${statReport.year}`,
                                status: statReport.status,
                            })
                        })
                        this.paginationOrder.current_page = res.current_page;
                        this.paginationOrder.from = res.from;
                        this.paginationOrder.last_page = res.last_page;
                        this.paginationOrder.per_page = res.per_page;
                        this.paginationOrder.total = res.total;
                        this.paginationOrder.to = res.to;
                        this.isLoading = false;
                    })
                }
            },
            getPaginationLogin(page) {
                if (this.count_search_login === null) {
                    this.isLoading = true;
                    Service.Common.getHistoryLogin(page).then(res => {
                        this.showDataSearchHistoryLogin = [];
                        res.data.forEach(history_login => {
                            this.showDataSearchHistoryLogin.push({
                                user_id: `${history_login.user_id}`,
                                user_name: `${history_login.user.firstname} ${history_login.user.lastname}`,
                                name_department: history_login.user.organization === null ? '-' : history_login.user.organization.name,
                                keyword_search: history_login.keyword_search,
                                updated_at: `${history_login.updated_at}`,
                                ip_address: `${history_login.ip_address}`,
                                id: `${history_login.id}`,
                            })
                            this.json_history_login.push({
                                'รหัสผู้ใช้งาน': `${history_login.user_id}`,
                                'ชื่อ-นามสกุล': `${history_login.user.firstname} ${history_login.user.lastname}`,
                                'ชื่อหน่วยงาน': history_login.user.organization === null ? '-' : history_login.user.organization.name,
                                'ประวัติการค้นหา': history_login.keyword_search === null ? '-' : history_login.keyword_search,
                                'ประวัติการเข้าใช้งาน': `${history_login.updated_at}`,
                                'IP Address': `${history_login.ip_address}`,
                            })
                            this.isLoading = false;
                        })
                        this.paginationLogin.current_page = res.current_page;
                        this.paginationLogin.from = res.from;
                        this.paginationLogin.last_page = res.last_page;
                        this.paginationLogin.per_page = res.per_page;
                        this.paginationLogin.total = res.total;
                        this.paginationLogin.to = res.to;
                    })
                } else {
                    this.isLoading = true;
                    let data = {
                        page: page,
                        organization_id: this.selectDepartment,
                        user_name: this.user_name,
                        date_start: this.historyLoginDateStart,
                        date_end: this.historyLoginDateEnd,
                    }
                    this.showDataSearchHistoryLogin = [];
                    Service.Common.getSearchHistoryLogin(data.page,data.organization_id, data.user_name, data.date_start, data.date_end).then(res => {
                        res.data.forEach(history_login => {
                            this.showDataSearchHistoryLogin.push({
                                user_id: `${history_login.user_id}`,
                                user_name: `${history_login.user.firstname} ${history_login.user.lastname}`,
                                name_department: `${history_login.user.organization.name}`,
                                keyword_search: history_login.keyword_search === null ? '-' : history_login.keyword_search,
                                updated_at: `${history_login.updated_at}`,
                                ip_address: `${history_login.ip_address}`,
                                id: `${history_login.id}`,
                            })
                            this.isLoading = false;
                        })
                        this.paginationLogin.current_page = res.current_page;
                        this.paginationLogin.from = res.from;
                        this.paginationLogin.last_page = res.last_page;
                        this.paginationLogin.per_page = res.per_page;
                        this.paginationLogin.total = res.total;
                        this.paginationLogin.to = res.to;
                    })
                }
            },
            getPaginationNotPrint(page) {
                if (this.count_search_not_print === null) {
                    this.isLoading = true;
                    this.showDataSearchNotPrint = [];
                    Service.Report.getToolNotPrintOverFiveYear(page).then(res => {
                        res.data.forEach(data_not_print => {
                            this.showDataSearchNotPrint.push({
                                id: `${data_not_print.id}`,
                                spec_no: `${data_not_print.spec_no}`,
                                // mainGroupSp: data_not_print.spec_group_.main_group_desc,
                                mainGroupSp: this.checkTryCash2(data_not_print,'spec_group_','main_group_desc'),
                                nameSpTh: `${data_not_print.name_th}`,
                                nameSpEn: `${data_not_print.name_en}`,
                                datePrint : `${data_not_print.last_date}`,
                                status: data_not_print.status,
                            })
                            this.json_data_not_print.push({
                                'เลขที่ สป.': `${data_not_print.spec_no}`,
                                'กลุ่มหลัก สป.': this.checkTryCash2(data_not_print,'spec_group_','main_group_desc'),
                                'ชื่อ สป.': `${data_not_print.name_th}`,
                                'ชื่อ สป.(อังกฤษ)': data_not_print.name_en ? data_not_print.name_en : '-',
                                'วันที่ถูกจัดพิมพ์ล่าสุด' : `${data_not_print.last_date}`,
                                'สถานะอุปกรณ์': data_not_print.status === '1' ? 'ใช้งาน' : 'ยกเลิก',
                            })
                        })
                        this.paginationNotPrint.current_page = res.current_page;
                        this.paginationNotPrint.from = res.from;
                        this.paginationNotPrint.last_page = res.last_page;
                        this.paginationNotPrint.per_page = res.per_page;
                        this.paginationNotPrint.total = res.total;
                        this.paginationNotPrint.to = res.to;
                        this.isLoading = false;
                    })
                } else{
                    this.isLoading = true;
                    let data = {
                        page: page,
                        date_start: this.notPrintDateStart,
                        date_end: this.notPrintDateEnd,
                    }
                    this.showDataSearchNotPrint = [];
                    Service.Report.getSearchNotOrder(data.page,data.date_start,data.date_end).then(res => {
                        res.data.forEach(data_not_print => {
                            this.showDataSearchNotPrint.push({
                                id: `${data_not_print.id}`,
                                spec_no: `${data_not_print.spec_no}`,
                                mainGroupSp: this.checkTryCash2(data_not_print,'spec_group_','main_group_desc'),
                                // mainGroupSp: data_not_print.spec_group_.main_group_desc,
                                nameSpTh: `${data_not_print.name_th}`,
                                nameSpEn: `${data_not_print.name_en}`,
                                datePrint : `${data_not_print.last_date}`,
                                status: data_not_print.status,
                            })
                            this.isLoading = false;
                        })
                        this.paginationNotPrint.current_page = res.current_page;
                        this.paginationNotPrint.from = res.from;
                        this.paginationNotPrint.last_page = res.last_page;
                        this.paginationNotPrint.per_page = res.per_page;
                        this.paginationNotPrint.total = res.total;
                        this.paginationNotPrint.to = res.to;
                    })
                }
            },

            checkTryCash3(specTool, para1, para2, para3) {
                try {
                    if (specTool[para1][para2][para3]) {
                        return specTool[para1][para2][para3]
                    }else {
                        return "-"
                    }
                }catch(e) {
                    return "-"
                }
            },
            checkTryCash2(specTool, para1, para2) {
                try {
                    if (specTool[para1][para2]) {
                        return specTool[para1][para2]
                    }else {
                        return "-"
                    }
                }catch(e) {
                    return "-"
                }
            },

            // Get PDF
            getHistoryOrderPdf(id,order_id) {
                window.open(process.env.VUE_APP_URL_API+'/api/get-history-order-pdf/'+id+'?order_id='+order_id);
            },

            // Export******************************************************
            onExportLikeAndDisLike() {
                this.isLoading = true;
                const dataWS = XLSX.utils.json_to_sheet(this.json_like_and_dislike)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb,'ประเมินความพึงพอใจระบบ.xlsx')
                this.isLoading = false;
            },
            onExportStat() {
                const dataWS = XLSX.utils.json_to_sheet(this.json_stat_printing)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb,'สถิติการสั่งพิมพ์ทั้งหมด.xlsx')
            },
            onExportHistoryOrder() {
                const dataWS = XLSX.utils.json_to_sheet(this.json_history_order)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb,'ประวัติการพิมพ์เพื่อจัดหา.xlsx')
            },
            onExportHistoryLogin() {
                const dataWS = XLSX.utils.json_to_sheet(this.json_history_login)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb,'ประวัติการเข้าใช้งานทั้งหมด.xlsx')
            },
            onExportToolNotPrint() {
                const dataWS = XLSX.utils.json_to_sheet(this.json_data_not_print)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb,'สป_ที่ไม่ถูกจัดพิมพ์เกิน_5_ปี.xlsx')
            },
        },


    }
</script>

<style lang="scss">
  .report-tab-1 {
    label.v-label.theme--dark {
      position: unset !important;
    }

    v-list-item:hover {
      background-color: #527281 !important;
    }

    .v-input input {
      min-height: 36px;
    }

  }

  .report-tab-2 {
    label.v-label.theme--dark {
      position: unset !important;
    }
  }

  .report-tab-3 {
    label.v-label.theme--dark {
      position: unset !important;
    }
  }


</style>
